module.exports = __webpack_public_path__ + "static/footer-f39f8c523a10df0e700f9316122f40a7.png";